import React, { useState } from "react";
import { Row, Col, Button, Segmented, Spin } from "antd";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { StyledTable } from "atoms/Table";
import { useSelector } from "react-redux";
import { getMinePerformanceList } from "redux/selectors";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";

const Viewperformance = () => {
  const history = useHistory();
  const { id } = useParams();
  const [completedsegment, setCompletedSegment] = useState([]);
  const [appraisalIndex, setAppraisalIndex] = useState(1);

  const minePerformanceList = useSelector(getMinePerformanceList);
  let filteredData =
    minePerformanceList?.find((item) => item?.contractid?.toString() === id) ||
    [];

  let apraiseemailid = filteredData.apraiseemailid;
  let appraiseeRoletype = filteredData.appraiseeroletype;

  const appraisalInformation = appraiseeRoletype.map((role) => ({
    roletype: role,
    appraiseeMailid: apraiseemailid
  }));

  const [selectedSegment, setSelectedSegment] = useState(
    appraisalInformation?.[0]?.roletype || null
  );
  const handleSegmentChange = (value) => {
    const index = appraisalInformation.findIndex(
      (item) => item.roletype === value
    );

    setSelectedSegment(value);
    setAppraisalIndex(index + 1);
    setCompletedSegment((prev) => {
      if (!prev.includes(index)) {
        return [...prev, index - 1];
      }
      return prev;
    });
  };
  const columns = [
    {
      title: "Objectives",
      dataIndex: "objectives",
      key: "objectives",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Weightage(%)",
      dataIndex: "weightage",
      key: "weightage",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "What went well/Major achievement",
      dataIndex: "whatwentwellmajorachivement",
      key: "whatwentwellmajorachivement",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "What can be improved / Challenges",
      dataIndex: "whatdidnotgowellchallenges",
      key: "whatdidnotgowellchallenges",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Self Score",
      dataIndex: "selfscore",
      key: "selfscore",
      render: (_, record) => {
        return record?.selfscore || record?.selfScore || "-";
      },
    },
  ];

  const columns1 = [
    {
      title: "Objectives",
      dataIndex: "objectives",
      key: "objectives",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Weightage(%)",
      dataIndex: "weightage",
      key: "weightage",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Major achievement",
      dataIndex: "whatwentwellmajorachivement",
      key: "whatwentwellmajorachivement",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Challenges",
      dataIndex: "whatdidnotgowellchallenges",
      key: "whatdidnotgowellchallenges",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Self Score",
      dataIndex: "selfscore",
      key: "selfscore",
      render: (_, record) => {
        return record?.selfscore || record?.selfScore || "-";
      },
    },
  ];

  return (
    <Customstyle>

      <>
        <SegmentWrap
          options={appraisalInformation?.map((item, index) => ({
            label: (
              <div style={{ display: "flex", alignItems: "center" }}>
                {item.roletype}
              </div>
            ),
            value: item.roletype,
          }))}
          value={selectedSegment}
          onChange={(value) => {
            handleSegmentChange(value);
          }}
        />
        <h6>
          <span
            className="title"
            onClick={() => history.push("/performancemanagement")}
          >
            Performance Management
          </span>{" "}
          <span>&gt;</span>
          {filteredData?.performancecontractname}
        </h6>
        <br />
        <h4>Your Response</h4>
        <br />
        {appraisalInformation?.map((val) =>
          val?.roletype === selectedSegment &&
            Object.keys(filteredData)?.length ? (
            <>
              <h5>Individual Assessment</h5>
              <Row gutter={12}>
                <Col xs={24} md={12}>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Client Survey Average Score
                    </div>
                    <div className="col-value">
                      {" "}
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.clientsurveyscore || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      VTP Appraisal Average Score
                    </div>
                    <div className="col-value">
                      {" "}
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.vtpappraisalscore || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      LMS – 40 hrs (target to actual %)
                    </div>
                    <div className="col-value">
                      {" "}
                      {filteredData
                        ?.individualassessment[selectedSegment]?.lmstarget ||
                        "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">Non–Chargeable %</div>
                    <div className="col-value">
                      {""}
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.nonchargeable || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      No. of Credentials Inputted
                    </div>
                    <div className="col-value">
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.noofcredentialsinputted || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Avg Time-sheet approval delays in days
                    </div>
                    <div className="col-value">
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.avgtimesheetapprovedelaydays || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      No. of assignments worked on
                    </div>
                    <div className="col-value">
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.noofassignmentsworked || "-"}
                    </div>
                  </div>

                  <div className="rows pt-2 pb-2">
                    <div className="col-label">Employee Profit/Loss</div>
                    <div className="col-value">
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.employeeprofitloss || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">No.of leads Created</div>
                    <div className="col-value">
                      {filteredData
                        ?.individualassessment[selectedSegment]?.noofleads ||
                        "-"}
                    </div>
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Engagement Appraisal Average Score
                    </div>
                    <div className="col-value">
                      {" "}
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.engagementappraisalscore || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">Leaves Taken (Days)</div>
                    <div className="col-value">
                      {" "}
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.leavetakendays || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Chargeability (Target to Actual %)
                    </div>
                    <div className="col-value">
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.chargeability || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">CV Last Updated (Date)</div>
                    <div className="col-value">
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.cvlastupdateddate
                        ? moment(
                          filteredData
                            ?.individualassessment[selectedSegment]
                            ?.cvlastupdateddate
                        ).format("Do MMM YYYY")
                        : "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Avg Time-sheet delays in days
                    </div>
                    <div className="col-value">
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.avgtimesheetdelaydays || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Average Task Delays in Days (VTP)
                    </div>
                    <div className="col-value">
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.avgtaskdelaydays || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">Employee Billing</div>
                    <div className="col-value">
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.employeebilling || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.employeebilling || "-"}
                    </div>
                    <div className="col-value">
                      $
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.amountsofproposal || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Proposal Conversion Rates(%)
                    </div>
                    <div className="col-value">
                      {filteredData
                        ?.individualassessment[selectedSegment]
                        ?.proposalconversionrate || "-"}
                    </div>
                  </div>
                </Col>
              </Row>
              <br />
              <br />
              <h6>Departmental/Country/Cluster level assessment</h6>
              <Row gutter={12}>
                <Col xs={24} md={12}>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Revenue, Rev vs budget, and GOLY%
                    </div>
                    <div className="col-value">
                      {filteredData?.clusterlevel[
                        selectedSegment
                      ]?.revenuerevvsbudgetandgoly || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">Rev/ Profit per employee</div>
                    <div className="col-value">
                      {filteredData?.clusterlevel[
                        selectedSegment
                      ]?.revprofitperemployee || "-"}
                    </div>
                  </div>

                  <div className="rows pt-2 pb-2">
                    <div className="col-label">Debtors in USD and days</div>
                    <div className="col-value">
                      {filteredData?.clusterlevel[
                        selectedSegment
                      ]?.debotorsinusdanddays || "-"}
                    </div>
                  </div>
                </Col>

                <Col xs={24} md={12}>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Departmental Profit, vs budget, GOLY %
                    </div>
                    <div className="col-value">
                      {filteredData?.clusterlevel[
                        selectedSegment
                      ]?.departmentalprofitvsbudgetgoly || "-"}
                    </div>
                  </div>
                  <div className="rows pt-2 pb-2">
                    <div className="col-label">
                      Employee cost, Profits as a %age of rev
                    </div>
                    <div className="col-value">
                      {filteredData?.clusterlevel[
                        selectedSegment
                      ]?.employeecostprofitsasageofrev || "-"}
                    </div>
                  </div>
                </Col>
              </Row>
              <br />
              <br />
              <h6>Technical Assessment</h6>
              <StyledTable
                columns={columns}
                dataSource={
                  filteredData?.reviewtechnicalassessment[
                  selectedSegment
                  ] || []
                }
                className="custom-table"
                size="middle"
                pagination={false}
              //loading={loading}
              />
              <br />
              <br />
              <h6>Individual (Soft Skills) Assessment / BDO Values</h6>
              <StyledTable
                columns={columns1}
                dataSource={
                  filteredData?.bdovalues[
                  selectedSegment
                  ] || []
                }
                className="custom-table"
                size="middle"
                pagination={false}
              //loading={loading}
              />
              <br />
              <br />
              <h6>Overall Summary</h6>
              <br />
              <p className="text" style={{ marginTop: "-10px" }}>
                {filteredData?.individualassessment[
                  selectedSegment
                ]?.overallsummary || "-"}
              </p>
              <br />
              <br />
              <br />
            </>
          ) : null
        )}
        <div className="footer">
          <Button
            className="footer-button"
            type="primary"
            onClick={() => history.goBack()}
          >
            Back
          </Button>
        </div>
      </>

    </Customstyle>
  );
}

export default Viewperformance;

const Customstyle = styled.div`
  .title {
    color: #636980;
    cursor: pointer;
  }
  .rows {
    display: flex;
    justify-content: space-between;
  }
  .col-label {
    color: #636980;
  }
  .col-value {
    margin-left: 40px;
    width: 98px;
    height: 18px;
    gap: 0px;
    opacity: 0px;
  }
  .text {
    font-size: 16px;
    font-weight: 400;
  }
  .footer {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 78%;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 12px 54px;
    background: white;
    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
  }
  .footer-button {
    width: 100px;
    height: 35px;
    font-size: 16px;
    border-radius: 8px;
  }
`;
const SegmentWrap = styled(Segmented)`
  position: sticky;
  top: 40px;
  float: right;
  background-color: #fff;
  z-index: 100;
  border: 1px solid #ffffff;
  color: #636980;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  .ant-segmented-item-selected {
    background-color: #c2fae5 !important;
    color: black;
  }
`;
